import { render, staticRenderFns } from "./projectContractDetails.vue?vue&type=template&id=6e6ee97e&scoped=true"
import script from "./projectContractDetails.vue?vue&type=script&lang=js"
export * from "./projectContractDetails.vue?vue&type=script&lang=js"
import style0 from "./projectContractDetails.vue?vue&type=style&index=0&id=6e6ee97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ee97e",
  null
  
)

export default component.exports